<template>
  <div class="zyc-header">
    <button @click="back" v-if="isBack">&nbsp;</button>
    <div :class="active == 'leftBtn'? 'zyc-header-btn-left-active':'zyc-header-btn-left'" @click="leftClick" v-if="isLeftBtn && leftTitle">{{ leftTitle }}</div>
    <div :class="active == 'rightBtn'?'zyc-header-btn-right-active':'zyc-header-btn-right'" @click="rightClick" v-if="isRightBtn && rightTitle"><span>{{ rightTitle }}</span></div>
    <div style="margin-left: 200px!important;" :class="active == 'rightBtnTwo'?'zyc-header-btn-right-active-two':'zyc-header-btn-right-two'" @click="rightClickTwo" v-if="isRightBtnTwo && rightTitleTwo"><span>{{ rightTitleTwo }}</span></div>
    <div class="zyc-header-line"></div>
    <h3><span></span><slot></slot></h3>
    <div class="zyc-header-line"></div>
  </div>
</template>
<script>
  /**
  * 头部容器
  */
  export default {
    name: 'zycHeader',
    props: {
      leftTitle: {
        type: String,
        default: ''
      },
      isLeftBtn: {
        type: Boolean,
        default: false
      },
      leftClick: {
        type: Function,
        default: function () { }
      },
      rightTitle: {
        type: String,
        default: ''
      },
      isRightBtn: {
        type: Boolean,
        default: false
      },
      rightClick: {
        type: Function,
        default: function () { }
      },
      rightTitleTwo: {
        type: String,
        default: ''
      },
      isRightBtnTwo: {
        type: Boolean,
        default: false
      },
      rightClickTwo: {
        type: Function,
        default: function () { }
      },
      active: {
        type: String,
        default: 'leftBtn'
      },
      isBack: {
        type: Boolean,
        default: true
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {

    },
    created() {

    },
    methods: {
      back: function () {
        this.$router.back(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/headerContainer.vue